/**
 * The one map look for every MaJourneys map, web and app (owner, 2026-10-30:
 * "we need to use this style of map (colors) on everything on app and web").
 *
 * On the web the look lives in Google Cloud, on this Map ID: a vector map
 * reads its colours from the console, not from code. Every web map passes it.
 * A Map ID is not a secret, it is in every page that draws a map.
 */
export const BRAND_MAP_ID = "9d4eb564dd382c2736908fdc";

/**
 * The same look as colours, sampled from the Map ID's rendered tiles, for the
 * maps that cannot read a Map ID: the app's Google maps (Android) take them
 * as a `customMapStyle`, and anything drawn around a map can match them.
 */
export const PALE_MAP_COLORS = {
  land: "#f4f5fa",
  builtUp: "#eef0f7",
  park: "#e4eedf",
  water: "#cfd8ed",
  road: "#ffffff",
  roadStroke: "#e6e8f1",
  highway: "#f2e6cb",
  highwayStroke: "#e3d2a8",
  label: "#5b5d75",
  labelStroke: "#ffffff",
  waterLabel: "#7d8db3",
} as const;

const c = PALE_MAP_COLORS;

/** Google Maps JSON style (legacy `styles` / react-native-maps `customMapStyle`). */
export const PALE_MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: c.land }] },
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: c.label }] },
  { elementType: "labels.text.stroke", stylers: [{ color: c.labelStroke }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
  { featureType: "landscape.man_made", elementType: "geometry", stylers: [{ color: c.builtUp }] },
  { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: c.land }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: c.park }, { visibility: "on" }] },
  { featureType: "road", elementType: "geometry.fill", stylers: [{ color: c.road }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: c.roadStroke }] },
  { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: c.highway }] },
  { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: c.highwayStroke }] },
  { featureType: "road.highway", elementType: "labels.icon", stylers: [{ visibility: "on" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: c.water }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: c.waterLabel }] },
];
